$bog_blitz_blog $mol_book2
	title \Blitz Quiz — Блог
	Placeholder $mol_view sub / <= Menu
	pages <= blog_pages /
	Menu $bog_blitz_blog_menu
		items *
			about \О проекте
			guide \Как создать квиз
			features \Возможности
			collab \Коллаборативное редактирование
		page? <=> page? \
	Page* $bog_blitz_blog_page
		slug <= page_slug* \
	App_link $mol_link
		arg *
			screen null
		title \Открыть Blitz Quiz
		uri \https://b-on-g.github.io/blitz/
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_calm_light
			theme_dark \$mol_theme_calm_dark
			themes /
				\$mol_theme_calm_light
				\$mol_theme_calm_dark
